export default __webpack_public_path__ + "static/media/cat_5.bcf26c57.PNG";